import React from "react";
import { Outlet } from "react-router-dom";
import LandingNavbar from "./LandingNavbar";
import MarketingFooter from "./MarketingFooter";

export default function MarketingLayout() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <LandingNavbar />
      <main className="min-h-[calc(100vh-88px)]">
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
